module.exports = __webpack_public_path__ + "static/scale-model-of-tourism-division-in-salem-oregon-de57910e9e498e607d70114fb9e07fec.png";